import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

import {
  AcademyEduModulePublicFilter,
  AcademyEduModulePublicFilter1,
  AcademyEduModulePublicWithRelations,
} from '../sdk-api';
import { UserAcademyEduModuleControllerApi } from '../sdk-api/api/userAcademyEduModuleController.service';
import { AcademyEduItem } from '../sdk-api/model/academyEduItem';
import {
  ClinicalCaseWithDigitalTutorSurveyCount,
  DigitalTutorSurveyService,
} from './digital-tutor-survey.service';

@Injectable({
  providedIn: 'root',
})
export class AcademyEduModuleService {
  currentModule: AcademyEduModulePublicWithRelations;
  digitalTutorClinicalCasesWithCount: ClinicalCaseWithDigitalTutorSurveyCount[];
  defaultLimit = 20;
  defaultFilter: AcademyEduModulePublicFilter = {
    limit: this.defaultLimit,
    skip: 0,
    order: ['created ASC'],
  };
  constructor(
    private _digitalTutorSurveyService: DigitalTutorSurveyService,
    private _userAcademyEduModuleControllerApi: UserAcademyEduModuleControllerApi,
  ) {}

  addCompletedItem(eduItem: AcademyEduItem): Observable<void> {
    return this._userAcademyEduModuleControllerApi.userAcademyEduModuleControllerAcademyEduItemCompleted(
      this.currentModule.id,
      eduItem.id,
    );
  }

  checkCompletedItems(
    moduleItems: Array<string>,
    userModuleItems: Array<string>,
  ): boolean {
    return (
      moduleItems.length === userModuleItems.length &&
      moduleItems.every((el) => userModuleItems.includes(el))
    );
  }

  getAcademyEduModules(
    filter: AcademyEduModulePublicFilter1,
  ): Observable<AcademyEduModulePublicWithRelations[]> {
    return this._userAcademyEduModuleControllerApi.userAcademyEduModuleControllerFind(
      JSON.stringify(filter) as unknown,
    );
  }

  getDigitalTutorClinicalCasesWithCount(): void {
    this.digitalTutorClinicalCasesWithCount =
      this._digitalTutorSurveyService.clinicalCaseWithUserSurveyCount(
        this.currentModule.id,
        this.currentModule.digitalTutorClinicalCases,
      );
  }

  findCurrentAcademyEduModule(
    eduModuleId: string,
  ): Observable<AcademyEduModulePublicWithRelations> {
    const filter: AcademyEduModulePublicFilter = {
      ...this.defaultFilter,
      include: [
        {
          relation: 'digitalTutorClinicalCases',
          scope: {
            limit: 10,
            order: ['created DESC'],
          },
        },
      ],
    };
    return this._userAcademyEduModuleControllerApi
      .userAcademyEduModuleControllerFindById(
        eduModuleId,
        JSON.stringify(filter) as unknown,
      )
      .pipe(finalize(() => this.getDigitalTutorClinicalCasesWithCount()));
  }
}
